import { render, staticRenderFns } from "./ModalCreateMerchant.vue?vue&type=template&id=5043099c&"
import script from "./ModalCreateMerchant.vue?vue&type=script&lang=js&"
export * from "./ModalCreateMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModalCreateMerchant.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5043099c')) {
      api.createRecord('5043099c', component.options)
    } else {
      api.reload('5043099c', component.options)
    }
    module.hot.accept("./ModalCreateMerchant.vue?vue&type=template&id=5043099c&", function () {
      api.rerender('5043099c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/ModalCreateMerchant.vue"
export default component.exports